(function () {
  function initGallery(root) {
    var track = root.querySelector('[data-chapter-gallery-track]');
    var currentEl = root.querySelector('[data-chapter-gallery-current]');
    var totalEl = root.querySelector('[data-chapter-gallery-total]');
    if (!track) return;

    var slides = track.querySelectorAll('[data-chapter-slide]');
    if (totalEl) totalEl.textContent = slides.length;

    var videoItems = [];
    slides.forEach(function (slide) {
      var video = slide.querySelector('video');
      if (!video) return;

      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.removeAttribute('controls');

      videoItems.push({ slide: slide, video: video });
    });

    function getVisibleIndex() {
      var trackWidth = track.clientWidth || 1;
      return Math.round(track.scrollLeft / trackWidth);
    }

    function updateCounter() {
      if (!currentEl) return;
      var index = getVisibleIndex();
      currentEl.textContent = Math.min(slides.length, Math.max(1, index + 1));
    }

    function playVisibleVideo() {
      if (!videoItems.length) return;

      var visibleIndex = getVisibleIndex();

      videoItems.forEach(function (item, index) {
        if (index === visibleIndex) {
          var playPromise = item.video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {});
          }
        } else {
          item.video.pause();
          item.video.currentTime = 0;
        }
      });
    }

    function refreshGallery() {
      updateCounter();
      playVisibleVideo();
    }

    track.addEventListener('scroll', refreshGallery, { passive: true });
    refreshGallery();

    if (videoItems.length) {
      window.addEventListener('load', refreshGallery, { once: true });
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) refreshGallery();
      });
    }
  }

  function initAccordions(root) {
    root.querySelectorAll('[data-chapter-accordion-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('[data-chapter-accordion]');
        var panel = item.querySelector('[data-chapter-accordion-panel]');
        var icon = trigger.querySelector('[data-chapter-accordion-icon]');
        var isOpen = panel.classList.contains('is-open');

        root.querySelectorAll('[data-chapter-accordion-panel].is-open').forEach(function (openPanel) {
          openPanel.classList.remove('is-open');
        });
        root.querySelectorAll('[data-chapter-accordion-icon]').forEach(function (openIcon) {
          openIcon.textContent = '+';
        });
        root.querySelectorAll('[data-chapter-accordion-trigger]').forEach(function (openTrigger) {
          openTrigger.setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          panel.classList.add('is-open');
          if (icon) icon.textContent = '−';
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initQty(form) {
    var minus = form.querySelector('[data-chapter-qty-minus]');
    var plus = form.querySelector('[data-chapter-qty-plus]');
    var input = form.querySelector('[data-chapter-qty-input]');
    if (!minus || !plus || !input) return;

    minus.addEventListener('click', function () {
      var min = parseInt(input.min || '1', 10);
      var val = parseInt(input.value || '1', 10);
      input.value = Math.max(min, val - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    plus.addEventListener('click', function () {
      var max = input.max ? parseInt(input.max, 10) : null;
      var val = parseInt(input.value || '1', 10);
      var next = val + 1;
      if (max) next = Math.min(max, next);
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function initVariantPicker(section) {
    var form = section.querySelector('[data-chapter-product-form]');
    if (!form) return;

    var variantInput = form.querySelector('[name="id"]');
    var priceEl = section.querySelector('[data-chapter-price]');
    var volumeEl = section.querySelector('[data-chapter-volume]');
    var variants = [];

    try {
      variants = JSON.parse(section.getAttribute('data-variants') || '[]');
    } catch (e) {
      variants = [];
    }

    function formatMoney(cents) {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        minimumFractionDigits: 0,
      }).format(cents / 100);
    }

    function selectVariant(variantId) {
      var variant = variants.find(function (v) {
        return String(v.id) === String(variantId);
      });
      if (!variant || !variantInput) return;

      variantInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price).replace('₹', '').trim();
      if (volumeEl && variant.title) volumeEl.textContent = '[' + variant.title.toUpperCase() + ']';

      section.querySelectorAll('[data-chapter-variant-id]').forEach(function (btn) {
        btn.classList.toggle('is-selected', String(btn.getAttribute('data-chapter-variant-id')) === String(variant.id));
      });

      var atc = form.querySelector('[data-chapter-atc]');
      var atcLabel = form.querySelector('[data-chapter-atc-label]');
      var buyNow = form.querySelector('[data-chapter-buy-now]');
      var stickyBuy = section.querySelector('[data-chapter-sticky-buy-btn]');
      var soldOut = !variant.available;

      if (atc) {
        atc.disabled = soldOut;
        if (atcLabel) {
          atcLabel.textContent = soldOut ? 'SOLD OUT' : 'ADD TO CART';
        } else {
          atc.textContent = soldOut ? 'SOLD OUT' : 'ADD TO CART';
        }
      }
      if (buyNow) buyNow.disabled = soldOut;
      if (stickyBuy) stickyBuy.disabled = soldOut;
    }

    section.querySelectorAll('[data-chapter-variant-id]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectVariant(btn.getAttribute('data-chapter-variant-id'));
      });
    });
  }

  function initIfThisWasSwiper() {
    if (typeof Swiper === 'undefined') return;

    document.querySelectorAll('[data-chapter-if-swiper]').forEach(function (el) {
      if (el.swiper) return;

      new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        freeMode: {
          enabled: true,
          momentum: true,
        },
        grabCursor: true,
        speed: 700,
      });
    });
  }

  function formatTestimonialQuote(text) {
    text = (text || '').trim().replace(/^["“”]+|["“”]+$/g, '');
    return text ? '"' + text + '"' : '';
  }

  function initTestimonials(root) {
    var slides = root.querySelectorAll('[data-chapter-testimonial-slide]');
    if (!slides.length) return;

    var index = 0;
    var busy = false;
    var photos = root.querySelectorAll('[data-chapter-testimonial-photo]');
    var quote = root.querySelector('[data-chapter-testimonial-quote]');
    var prev = root.querySelector('[data-chapter-testimonial-prev]');
    var next = root.querySelector('[data-chapter-testimonial-next]');
    var dots = root.querySelectorAll('[data-chapter-testimonial-dot]');
    var cache = {};

    function preload(src) {
      if (!src || cache[src]) return cache[src];
      cache[src] = new Promise(function (resolve) {
        var img = new Image();
        img.decoding = 'async';
        img.onload = function () { resolve(img); };
        img.onerror = function () { resolve(img); };
        img.src = src;
      });
      return cache[src];
    }

    slides.forEach(function (slide) {
      [1, 2, 3, 4].forEach(function (slot) {
        preload(slide.getAttribute('data-image-' + slot));
      });
    });

    function show(i) {
      if (busy) return;
      index = (i + slides.length) % slides.length;
      var slide = slides[index];
      var alt = slide.getAttribute('data-alt') || '';
      var nextQuote = formatTestimonialQuote(slide.getAttribute('data-quote') || '');
      var loads = [];

      photos.forEach(function (photo) {
        var slot = photo.getAttribute('data-chapter-testimonial-photo');
        var src = slide.getAttribute('data-image-' + slot);
        if (!src || photo.currentSrc === src || photo.src === src) return;
        loads.push(preload(src).then(function (img) {
          photo.src = img.currentSrc || img.src;
          photo.alt = alt;
        }));
      });

      var apply = function () {
        if (quote) quote.textContent = nextQuote;
        dots.forEach(function (dot, dotIndex) {
          dot.classList.toggle('is-active', dotIndex === index);
        });
        busy = false;
      };

      if (!loads.length) {
        apply();
        return;
      }

      busy = true;
      Promise.all(loads).then(apply);
    }

    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        show(parseInt(dot.getAttribute('data-chapter-testimonial-dot'), 10));
      });
    });

    show(0);
  }

  function initStickyBuyNow(section) {
    var form = section.querySelector('[data-chapter-product-form]');
    var buyNow = form && form.querySelector('[data-chapter-buy-now]');
    var sticky = section.querySelector('[data-chapter-sticky-buy]');
    var stickyBtn = section.querySelector('[data-chapter-sticky-buy-btn]');
    if (!buyNow || !sticky || !stickyBtn) return;

    var setVisible = function (show) {
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.body.classList.toggle('chapter-has-sticky-buy', show);
    };

    stickyBtn.addEventListener('click', function () {
      if (stickyBtn.disabled) return;
      buyNow.click();
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          if (!entry) return;
          setVisible(!entry.isIntersecting);
        },
        {
          threshold: 0,
          rootMargin: '0px 0px -8px 0px',
        }
      );
      observer.observe(buyNow);
    } else {
      var onScroll = function () {
        var rect = buyNow.getBoundingClientRect();
        setVisible(rect.bottom < 0 || rect.top > window.innerHeight);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  function initHeaderScroll() {
    var header = document.querySelector('.chapter-product-page .header-wrapper');
    if (!header) return;

    var scrollThreshold = 24;

    function onScroll() {
      var scrolled = window.scrollY > scrollThreshold;
      header.classList.toggle('header-scrolled', scrolled);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initRelatedSwiper() {
    if (typeof Swiper === 'undefined') return;

    document.querySelectorAll('[data-chapter-related-swiper]').forEach(function (el) {
      if (el.swiper) return;

      var swiper = new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 12,
        freeMode: {
          enabled: true,
          momentum: true,
          momentumRatio: 0.65,
        },
        grabCursor: true,
        speed: 650,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        resistanceRatio: 0.85,
      });

      el.querySelectorAll('.chapter-related__image').forEach(function (img) {
        if (img.complete) return;
        img.addEventListener('load', function () {
          swiper.update();
        }, { once: true });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-chapter-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-chapter-accordions]').forEach(initAccordions);
    document.querySelectorAll('[data-chapter-hero]').forEach(function (section) {
      var form = section.querySelector('[data-chapter-product-form]');
      if (form) initQty(form);
      initVariantPicker(section);
      initStickyBuyNow(section);
    });
    initIfThisWasSwiper();
    initRelatedSwiper();
    document.querySelectorAll('[data-chapter-testimonials]').forEach(initTestimonials);
    initHeaderScroll();
  });

  window.addEventListener('load', function () {
    initIfThisWasSwiper();
    initRelatedSwiper();
  });
})();
